import { createGlobalStyle } from 'styled-components';
import { accent, maxContainerWidth } from 'constants/theme';
import MEDIA from 'helpers/mediaTemplates';

export default createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    box-sizing: border-box;
  }
  b, strong {
    font-weight: 700;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

/* custom scrollBar */
  /* html {
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  } */
  html {
    scroll-behavior: smooth;
  }

  body {
    /* font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"; */
    font-family: "Inter", "Helvetica Neue","Segoe UI","Helvetica","Nimbus Sans L","Liberation Sans","Open Sans",FreeSans,sans-serif;
    line-height: 1;
    font-size: 1rem;
    color: #485963; 
    /* color: #485963 !important;  */
    /* color: #5c5c5c; */
    background-color: #fcfcfc;
    background: #fcfcfc;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "pnum";
    font-feature-settings: "pnum";
    font-variant-numeric: proportional-nums;

    
  }
  ::-moz-selection { background: #3ea1d782; color:#333; text-shadow: none; }
  ::selection { background: #3ea1d782; color:#333; text-shadow: none;}

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  *:focus {
    border-color: var(--accent-color);
    outline-color: var(--accent-color);
  }

  pre {
    display: block;
    padding: 2rem;
    margin-top: 4rem;
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    border-radius: 5px;
    color: ${accent};
    border: 1px solid #ddd;
    font-family: "SFMono-Regular",Consolas,"Liberation Mono",Menlo,Courier,monospace;
  }

  video {
    max-width: 100%;
  }

  p {
    margin-bottom: 2rem;
  }

  :root {
    --cyan: #30bbe5;
    --azulContrast: #006080;
    --azulVerdoso: #0987a0;
    --accent-color: #1f9ee4;
    --accent-color-txt: #1a94d5;
    --accent-light: #1f9ee477;
    --accent-lighter: rgba(0, 196, 255, 0.53);
    --accent-transparent: rgba(0, 196, 255, 0.06);
    --cf-color-blue: #1f9ee4;
  }

  .btnCta {
    background: hsl(202 91% 38% / 1); 
    /* background: #0f80b2;  */
    /* #257cb9; */
    border: none;
    color: #fff;
    border-radius: 3px;
    text-shadow: 1px 1px 1px #33333355;
    border-color: '#006080';
    text-shadow: 1px 1px 1px #333;
    /* height: 48px !important; */
  }
  .btnCta:hover {
    background: #3c9cdc;
  }
  .btnAzul {
    background: hsl(202 91% 38% / 1); 
    /* background: #0f80b2;  */
    /* #257cb9; */
    border: none;
    color: #fff;
    border-radius: 6px;
    text-shadow: 1px 1px 1px #33333355;
    border-color: '#006080';
    text-shadow: 1px 1px 1px #333;
    /* height: 48px !important; */
    padding: 13px 20px;
    box-shadow: 0px 9px 13px #bbb;
    font-weight: bold;
  }
  .btnAzul:hover {
    background: #3c9cdc;
  }

  .fondoVideo {
    iframe {
      pointer-events: none;
    }
  }
  .contenido {
    max-width: ${maxContainerWidth};
    margin: 0 auto;
  }
  .contenidoSmall {
    line-height: calc(1.5em + .2vw);
    font-size: calc(.95em + .2vw) !important;
    font-weight: normal;
    color: #222;
    max-width: 50em;//960px;//60em;
    margin: 0 auto;
  }
  h3 {
    font-size: calc(1.65em + .2vw);
  }
  .subHeader {
    font-size: calc(1.65em + .2vw) !important;
    margin-top: 0.4em;
    margin-bottom: 0.8em;
    text-align: center;
    
    /* background: -webkit-linear-gradient(to right, #4895b9, rgb(0, 196, 255));
    background: linear-gradient(to right, #4895b9, rgb(0, 196, 255)); */
    /*text-shadow: 3px 2px 3px rgba(202, 202, 202, 0.62);*/

    background: #314755;
    background: -webkit-linear-gradient(to right, #ff0000, var(--accent-color),  #8a5a86);
    background: linear-gradient(to right,  #ff0000, var(--accent-color),  #8a5a86);
    background-size: 100%;
    background-origin: 0;
    background-clip: text;
    text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .subHeader span {
    text-fill-color: white;
    -webkit-text-fill-color: white;
    /* margin:0 6px; */
  }
  .subHeaderSmall {
    font-size: calc(1.25em + .2vw) !important;
  } 
  .parrafo {
    margin-bottom: 1.2em;
    font-size: 21px;
    /* color: #485963;//#222; */
    /* margin: 0 auto 1.5em; */
    margin: 1em auto 2em;
    padding-left: 1em;
    padding-right: 1em;
    font-weight: 300;
    font-size: calc(1.3em + 0.2vw);//calc(1.3em + 0.2vw);
    line-height: 1.4;
    text-align: left;
    /* max-width: 30em; */
    max-width: 38em;//900px; //60em;
  }
  .parrafoGrande {
    font-size: 37px;
    font-size: calc(0.975rem + 1.6vw);
    font-size: calc(0.6rem + 1.2vw);
    line-height: 1.2;
    font-weight: bold;
    padding: 0;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
    max-width: 50em;
    padding-top: 1em;
    /* text-align: center; */
  }
  @media (max-width: 1024px) {
    .parrafoGrande {
      padding: 0.7em 1em;
    }
  }
  .parrafoChico {
    margin-bottom: 1.5em;
    line-height: calc(1.5em + .2vw);
    font-size: calc(.95em + .2vw) !important;
    font-weight: normal;
    /* color: #222; */
    max-width: 50em;
    margin: 0 auto 0.5em;
    padding-left: 1em;
    padding-right: 1em;
  }
  .spacer {
    border-bottom: 1px solid #e8e2e2;
    padding-bottom: 3em;
  }
.flexList {
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 2em auto;
  padding: 2em 0em;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  max-width: 76em;
}
.flexList .columna {
  /* justify-content: flex-start; */
  display: flex;
  flex-direction: column;
  padding: 1em;
  min-width: 39%;
  width: 100%;
  flex-basis: 250px;
  flex-grow: 1;
} 
.flexList .columna h3, .flexList .columna h2 {
  font-size: 1.2em;
  font-size: calc(1.2rem + 0.3vw) !important;
  margin-top: 0.4em;
  margin-bottom: 0.8em;
  text-align: center;
  
  background: #314755;
  /* background: -webkit-linear-gradient(to right, var(--accent-color), #ff0000, rgb(0, 196, 255), var(--accent-color-txt));
  background: linear-gradient(to right, var(--accent-color), #ff0000, rgb(0, 196, 255), var(--accent-color-txt)); */
  background: -webkit-linear-gradient(to right, #ff0000, var(--accent-color),  #8a5a86);
  background: linear-gradient(to right,  #ff0000, var(--accent-color),  #8a5a86);
  background-size: 100%;
  background-origin: 0;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.flexListLeft .columna {
  padding: 4em;
  
}
.flexListLeft .img {
  padding: 4em;
  justify-content: center;
}
.flexListLeft .full {
  padding: 0.3em;
  justify-content: center;
}
.flexListCompacta {
  padding: 0;
  border: none;
  margin-top: 2.5em;
  align-items: center;
  gap: 48px;
}
.flexListCompacta .columna {
  padding: 0;
}
${MEDIA.TABLET`
  .flexListLeft .columna {
    padding: 1em 1em;
  }
  .flexListLeft .img {
    padding: 1em 1em;
  }
  .flexListCompacta {
    margin-top: 2.5em;
  }
`}
${MEDIA.PHONE`
  .flexListLeft .columna {
    padding: 1em 1em;
  }
  .flexListLeft .img {
    padding: 1em 0.6em;
  }
  .flexListCompacta {
    margin-top: 1.5em;
  }
`}
.flexListLeft .columna h3, .flexListLeft .columna h2 {
  text-align: left;
}
.listaConIconos {
  margin: 1em 2em;
  text-indent: -2em;
  padding-left: 4em;
  ${MEDIA.PHONE`
    text-indent: -1em;
    padding-left: 2em;
    margin: 1em 0;
  `}
}
.listaConIconos li {
  line-height: 1.3;
}
.listaConIconos li svg {
  width: 1.5em;
  height: 1.5em;
  margin-right:.5em;
  margin-top: -0.2em;
}
.shadow-lg {
  border-radius: 10px;
  background: linear-gradient(145deg,#4e4e4e,#000000);
  box-shadow: 26px 26px 52px #4c4c4c, -26px -26px 52px #c1c1c1;
  padding: 4px;
}
.shadow-lg-white {
  border-radius: 10px;
  box-shadow: 26px 26px 52px #4c4c4c, -26px -26px 52px #c1c1c1;
  padding: 4px;
}
.shadow-lg video, .shadow-lg-white video {  
  border-radius: 6px; 
}
.round-fun {
  border-radius: 35px; 
}
.round-fun video {
  border-radius: 32px; 
}
.shadow-md {
  border-radius: 5px;
  background: linear-gradient(145deg,#4e4e4e,#000000);
  box-shadow: 16px 16px 42px #4c4c4c, -16px -16px 42px #c1c1c1;
  padding: 0.2em;
}
.shadow-md-white {
  box-shadow: 10px 10px 32px #4c4c4c, -10px -10px 32px #c1c1c1, inset 0 1px #ffffffaa;
  padding: 0.2em;
}
.shadow-sm {
  border-radius: 0px;
  background: linear-gradient(145deg,#4e4e4e,#000000);
  box-shadow: 8px 8px 42px #4c4c4c, -8px -8px 42px #c1c1c1;
  padding: 0em;
}
  ${MEDIA.PHONE`
    .fondoVideo {
      object-fit: scale-down;
      overflow: hidden;
      iframe {
        pointer-events: auto;
        width: 1050%;
        margin-left: -1750px;
      }
    }
    .subHeader {
      font-size: 21px !important;
    }
  `};

  .iconList {
    max-width: 80em;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .iconList div {
    /* display: flex; */
    width: 212px;
    flex-basis: 212px;
    flex-grow: 1;
    flex-shrink: 0;
  }
  .iconList iframe {
    /* display: flex; */
    width: 212px;
    flex-basis: 212px;
    flex-grow: 1;
    flex-shrink: 0;
  }
  ${MEDIA.PHONE`
    .iconListSmallOnMobile div {
      flex-basis: 150px;
    }
  `};



/* perspective Layers  */

  .perspectiveLayers {
    position: relative;
    height: 300px;
    ${MEDIA.PHONE`
        height: 150px;
    `};
    div {
      transform: scale(1) translateZ(0) translateX(0) translateY(0);
      
      transform-origin: 50% 100%;
    transform-style: preserve-3d;
      transition: 0.6s ease transform;
    }
    div {
      width: 100%;
      height: auto;
      position: absolute;
      background: transparent;
      transform-origin: 50% 100%;
      transform-style: preserve-3d;
      box-shadow: none;
      transition: 0.6s ease transform;

      img {
        box-shadow: none !important;
      }
    }
  }
  .perspectiveLayers:hover div:nth-of-type(5) {
    z-index: 5;
    transform:
      scale(0.75)
      rotateY(-30deg)
      rotateX(45deg)
      translateZ(4.5rem)
      translateX(calc( 0 * 5rem - 8rem ))
      translateY(calc( 0 * 5rem ));
  }
  .perspectiveLayers:hover div:nth-of-type(4) {
    z-index: 4;
    transform:
      scale(0.75)
      rotateY(-30deg)
      rotateX(45deg)
      translateZ(4.5rem)
      translateX(calc( 1 * 5rem - 8rem ))
      translateY(calc( 1 * 5rem ));
  }
  .perspectiveLayers:hover div:nth-of-type(3) {
    z-index: 3;
    transform:
      scale(0.75)
      rotateY(-30deg)
      rotateX(45deg)
      translateZ(4.5rem)
      translateX(calc( 2 * 5rem - 8rem ))
      translateY(calc( 2 * 5rem ));
  }
  .perspectiveLayers:hover div:nth-of-type(2) {
    z-index: 2;
    transform:
      scale(0.75)
      rotateY(-30deg)
      rotateX(45deg)
      translateZ(4.5rem)
      translateX(calc( 3 * 5rem - 8rem ))
      translateY(calc( 3 * 5rem ));
  }
  .perspectiveLayers:hover div:first-of-type {
    z-index: 1;
    transform:
      scale(0.75)
      rotateY(-30deg)
      rotateX(45deg)
      translateZ(4.5rem)
      translateX(calc( 4 * 5rem  - 8rem))
      translateY(calc( 4 * 5rem));
  }


/* perspective Layers inverted */

  .perspectiveLayersInverse {
    position: relative;
    height: 300px;
    ${MEDIA.PHONE`
        height: 150px;
    `};
    &:hover div {
      transform: scale(1) translateZ(0) translateX(0) translateY(0) !important;
      
      transform-origin: 50% 100%;
    transform-style: preserve-3d;
      transition: 0.6s ease transform;
    }
    div {
      width: 100%;
      height: auto;
      position: absolute;
      background: transparent;
      transform-origin: 50% 100%;
      transform-style: preserve-3d;
      box-shadow: none;
      transition: 0.6s ease transform;

      img {
        box-shadow: none !important;
      }
    }
  }
  .perspectiveLayersInverse div:nth-of-type(5) {
    z-index: 0;
    transform:
      scale(0.75)
      rotateY(-30deg)
      rotateX(45deg)
      translateZ(4.5rem)
      translateX(calc( 4 * 5rem - 8rem ))
      translateY(calc( 4 * 5rem ));
  }
  .perspectiveLayersInverse div:nth-of-type(4) {
    z-index: 0;
    transform:
      scale(0.75)
      rotateY(-30deg)
      rotateX(45deg)
      translateZ(4.5rem)
      translateX(calc( 3 * 5rem - 8rem ))
      translateY(calc( 3 * 5rem ));
  }
  .perspectiveLayersInverse div:nth-of-type(3) {
    z-index: 1;
    transform:
      scale(0.75)
      rotateY(-30deg)
      rotateX(45deg)
      translateZ(4.5rem)
      translateX(calc( 2 * 5rem - 8rem ))
      translateY(calc( 2 * 5rem ));
  }
  .perspectiveLayersInverse div:nth-of-type(2) {
    z-index: 2;
    transform:
      scale(0.75)
      rotateY(-30deg)
      rotateX(45deg)
      translateZ(4.5rem)
      translateX(calc( 1 * 5rem - 8rem ))
      translateY(calc( 1 * 5rem ));
  }
  .perspectiveLayersInverse div:first-of-type {
    z-index: 3;
    transform:
      scale(0.75)
      rotateY(-30deg)
      rotateX(45deg)
      translateZ(4.5rem)
      translateX(calc( 0 * 5rem  - 8rem))
      translateY(calc( 0 * 0rem));
  }

  /* Parallax Layers  */
  :root {
    --perspective: 8px;
  }
  .parallaxLayers {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    -webkit-overflow-scrolling: touch;
  }
  .parallaxLayers .container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    perspective: var(--perspective);
    perspective-origin: 0%;
  }
  .parallaxLayers .wrapper {
    /* position: absolute; */
    /* transform-origin: 0 50%;
    width: 920px;
    height: 420px; */
  }
  .parallaxLayers .wrapper div:first-of-type {
    /* position: absolute; */
    transform-origin: 0 50%;
    width: 920px;
    height: 840px;
    transform: translateZ(0px) scale(1);
  }
  .parallaxLayers .wrapper div:nth-of-type(2) {
  position: absolute;
    width: 920px;
    top: 75px;
    transform: translateZ(5px) scale(calc(var(--perspective - 5) / var(--perspective)));
  }
  .parallaxLayers .wrapper div:nth-of-type(3) {
  position: absolute;
    transform-origin: 0 50%;
    width: 920px;
    top: 50px;
    transform: translateZ(3px) scale(calc(var(--perspective - 3) / var(--perspective)));
  }
  .parallaxLayers .wrapper div:nth-of-type(4) {
   position: absolute;
    width: 920px;
    top: 25px;
    transform: translateZ(1px) scale(calc(var(--perspective - 1) / var(--perspective)));
  }


  .textoGrad {
    /* text-transform: uppercase; */
    color: var(--accent-color-txt); 
    background: -webkit-linear-gradient(to right, #01579B 0%, #000000 100%);
    background: linear-gradient(to right, #01579B 0%, #000000 100%);
    background-clip: text;
    text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: none !important;
  }
  .textoGrad2 {
    background: #314755;
    background: -webkit-linear-gradient(to right, #ff0000, var(--accent-color),  #8a5a86);
    background: linear-gradient(to right,  #ff0000, var(--accent-color),  #8a5a86);
    background-size: 100%;
    background-origin: 0;
    background-clip: text;
    text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .textoGrad2 span {}



  .headerImg {
    margin-top: -42px;
    min-height: 66vh;
  }
  .pageHeader {
    color: #fff;
    background: var(--accent-light);
    font-size: 1rem;
    font-size: calc(0.5em + 0.8vw);
    line-height: 38px;
    font-weight: bold;
    padding: 0;
    text-shadow: 3px 4px 4px rgba(0, 0, 0, 0.4);
    width: auto;
    border-radius: 0 0 0 12px;
    display: inline-block;
    padding: 6px 16px 0px 12px;
    margin-top: -8px;
    z-index: 2;
  }
  .headerTitleWrapper {
    max-width: 1024px;
    margin: 3em auto 1em;
    min-height: auto;
    justify-content: space-around;
    flex-direction: column;
  }
  .headerTitle {
    margin-top: -55vh;
    background: rgb(255 255 255 / 36%);
    backdrop-filter: blur(12px);
    border-radius: 12px;
    border: 1px solid black;
    box-shadow: -3px 6px 11px #333333c4;
    padding: 0.4em 0.6em 0.5em;
    font-size: 1.5em;
    line-height: 1.2;
    font-size: calc(1.625rem + 1.6vw);
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.25);
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
    text-size-adjust: 100%;
    max-width: 1440px;
    text-align: center;
    letter-spacing: -0.03rem;
    position: relative;
  }
  .headerTitle b {
    background: #314755;
    background: -webkit-linear-gradient(to right, #ff0000, var(--accent-color),  #8a5a86);
    background: linear-gradient(to right,  #ff0000, var(--accent-color),  #8a5a86);
    background-size: 100%;
    background-origin: 0;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  ${MEDIA.TABLET`
    .headerTitle {
      margin-top: -55vh;
      background: #ffffffbb;
    }
  `};
  ${MEDIA.PHONE`
    .pageHeader {
      font-size: 1.2em;
      line-height: 34px;
    }
    .parrafo {
      font-size: 1.2em;
      line-height: 1.3em;
      font-size: calc(1.1em + .2vw);
      line-height: calc(1.5em + .2vw);
      text-shadow: 0 1px 4px rgba(0,0,0,0.1);
      text-align: left;
    }
    .parrafoGrande {
      font-size: 1.4rem;
      font-size: calc(1.0975rem + 1.6vw);
      line-height: 1.2;
      font-weight: bold;
      padding: 0 1em;
      text-shadow: 0 1px 4px rgba(0,0,0,0.25);
      max-width: 100%;
      margin: 0em auto 2em;
    }
    .headerTitle {
      margin-top: 0;
      background: transparent;
      font-size: calc(1.375rem + 1.4vw);

      width: 100%;
      padding: 0em 0.7em;
      text-align: center;
      margin-bottom: 0.5em;

      border: 0;
      box-shadow: none;
    }
    .headerTitle b {
      background: #314755;
      background: -webkit-linear-gradient(to right, #ff0000, var(--accent-color),  #8a5a86);
      background: linear-gradient(to right,  #ff0000, var(--accent-color),  #8a5a86);
      background: -webkit-linear-gradient(to right, #314755, var(--accent-color),  #8a5a86);
      background: linear-gradient(to right,  #314755, var(--accent-color),  #8a5a86);

      background-size: 100%;
      background-origin: 0;
      background-clip: text;
      text-fill-color: transparent;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
      /* font-family: Calibri Bold,AvenirNext,Avenir,-apple-system,BlinkMacSystemFont,Roboto Slab,Droid Serif,Segoe UI,Oxygen-Sans,Ubuntu,Cantarell,Georgia,serif; */
    /* @media screen and (min-width: 768px) {
      .headerImg {
        min-height: 65vh;
        width: 100%;
      }
    } */
  `};

/* ---- Main Container Servicios  ---- */

.mainContainer {
  max-width: 920px;
  margin: 0 auto;
  /*padding: 6rem 3rem;*/
  font-size: 1.4em;
  line-height: 1.3em;

  padding: 0 1em;
  // ${MEDIA.TABLET`
  //   padding: 0 1em;
  // `};

  h3 {
    font-size: 40px;
    line-height: 45px;
    text-align: center;
    margin: 1em 0;
  }

  img {
    max-width: 100%;
    margin: 0 auto;
  }
  a {
    color: #2288cc;
  }


  section {
    padding: 20px 1em 60px 1em;
    overflow: auto;
    zoom: 1;
    max-width: 920px; 
    margin: 0 auto; 
    font-size: 19.4px;
    text-rendering: optimizeLegibility;
    letter-spacing: 1px;
  }
  ${MEDIA.PHONE`
  section {
    font-size: 18px;
  }
  `};
  h4, h2, h3 {
    font-size: 22px;
    font-weight: bold;
    color: #2288cc;
    line-height: 31px;
    text-align: center;
    margin: 1em 0;
  }
  h5 {
    font-size: 20px;
    font-weight: bold;
    color: #2288cc;
    line-height: 1.2;
    text-align: left;
    margin: 1.4em 0 1em;
  }
  h6 {
    font-size: 18px;
    font-weight: bold;
    /* color: #2288cc; */
    line-height: 1.2;
    text-align: left;
    margin: 1.2em 0 0.8em;
  }
  ul {
    list-style: circle;
    padding-left: 24px;
    padding-bottom: 16px;
  }
  .columnas2a1 {
    columns: 2;
    ${MEDIA.PHONE`
      columns: 1;
    `}
  }
}


/* ---- Shiny animated card (ej. baseball)  ---- */
:root {
  --delay: 0;
}
.flota {
  -webkit-animation: shimmy 12s ease-in-out infinite;
  animation: shimmy 12s ease-in-out infinite;
  border-radius: 23px;
  border-top: 2px solid rgb(255, 255, 255);
  animation-delay: var(--delay);
  // animation-duration: var(--delay)s;
}

@keyframes shimmy {
  0%,
  100% {
    transform: rotateY(-20deg) skewX(0deg) rotateX(10deg);
    box-shadow: 5px 1px 10px 3px #00000033, 0px -2px 3px white, 7px 6px 5px rgb(81, 81, 81), 2px 2px 1px rgba(255, 255, 255, 0.51);
  }
  50% {
    transform: rotateY(30deg) skewX(0deg) rotateX(10deg);
    box-shadow: -10px 10px 10px 10px #00000033, -7px 6px 5px rgb(81, 81, 81), 2px 2px 1px rgba(255, 255, 255, 0.51);
  }
}

.shine {
  overflow: hidden;
}
.shine::after {
  content: "";
  width: 1400px;
  height: 100px;
  top: -30px;
  margin-left: -130px;
  transform: rotate(30deg);
  background: -webkit-linear-gradient(top, transparent, rgba(200, 200, 200, 0.1), transparent);
  position: absolute;
  animation: shine 12s cubic-bezier(0.42, 0, 0.05, 0.99) infinite;
}

@keyframes shine {
  0%,
  100% {
    margin-top: -600px;
  }

  50% {
    margin-top: 1600px;
  }
}
.cardShadow {
  width: 875px;
  height: 5px;
  background: rgba(50, 50, 50, 0.1);
  margin: -15px auto 0 auto;
  box-shadow: 0px 0px 20px rgba(50, 50, 50, 0.1);
  animation: angle 12s ease-in-out infinite;
}

@keyframes angle {
  0%,
  100% {
    height: 5px;
  }
  50% {
    height: 15px;
    width: 860px;
    border-radius: 30% 90% 90% 30%;
    transform: skew(50deg, -10deg) translateX(13px);
  }
}

kbd {
  margin: 0;
  margin-right: 8px;
  padding: 0;
  border: 0;
  outline: 0;
  color: #999;
  font-size: 0.8em !important;
  // font-family: monospace, sans-serif;
  vertical-align: baseline;
  background: transparent;
  border-color: #e6e6e6 #bebebe #bebebe #e6e6e6;
  border-style: solid;
  border-width: 1px 2px 3px;
  padding: 0 5px;
  background-color: #d2d2d2;
  background-color: transparent; //rgb(34 136 204 / 12%);
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

/* ---- Contact Chat styles  ---- */


.conversational-form{text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;visibility:visible!important;font-family:"Helvetica Neue","Neue Helvetica W01",Helvetica,Arial,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol",sans-serif;font-size:18px;line-height:22px;position:absolute;top:0;left:0;right:0;bottom:0;z-index:999;margin:auto;background:#fff;overflow:hidden;opacity:0;will-change:opacity}.conversational-form *,.conversational-form :after,.conversational-form :before{box-sizing:border-box;outline:0}.conversational-form:before{content:"";width:100%;height:50px;pointer-events:none;background:linear-gradient(to bottom,#fff 0,rgba(255,255,255,0) 100%);position:absolute;top:0;left:0;z-index:2}.conversational-form button{border:none;background:0 0;margin:0;padding:0;outline:0;-webkit-tap-highlight-color:transparent!important}.conversational-form menu{padding:0;margin:0}.conversational-form li,.conversational-form ol,.conversational-form ul{margin:0;padding:0}.conversational-form a,.conversational-form a:active,.conversational-form a:visited{color:currentColor}.conversational-form a,.conversational-form button{cursor:pointer}@media (max-width:1152px){.conversational-form{font-size:16px;line-height:20px}}.conversational-form .conversational-form-inner{padding:0 20px;position:absolute;width:100%;min-height:100%;max-height:100%;bottom:0;height:auto;overflow:hidden;margin-bottom:auto;display:flex;flex-flow:column nowrap;justify-content:flex-end;align-items:baseline}@media (max-width:1152px){.conversational-form .conversational-form-inner{padding:0 14px}}.conversational-form--enable-animation .conversational-form{transition:opacity .1875s cubic-bezier(.215,.61,.355,1)}.conversational-form *{-webkit-tap-highlight-color:rgba(255,255,255,0);tap-highlight-color:rgba(255,255,255,0)}.conversational-form--show{opacity:1}cf-info{position:absolute;pointer-events:none;z-index:0;left:0;top:25%;height:auto;width:100%;text-overflow:ellipsis;padding-right:20px;margin-top:12px;overflow:hidden;display:block;transform:translateY(-115%);color:#000;opacity:1;will-change:opacity;font-size:12px}cf-info.show{opacity:1}.conversational-form--enable-animation cf-info.show{transition:opacity .75s cubic-bezier(.215,.61,.355,1)}cf-input{display:block;position:relative;width:100%;height:auto;margin-bottom:20px;margin-top:0;flex:0 0 auto;background:#fff}@media (max-width:1152px){cf-input{margin-bottom:14px}}cf-input .inputWrapper{position:relative}cf-input.animate-in input,cf-input.animate-in textarea{transition-delay:0s,0s,0s,.4s,.4s;opacity:1;transform:translateY(0) rotateX(0)}cf-input.animate-in cf-input-button.cf-input-button{transition-delay:0s,0s .75s;transform:scale(1,1)}cf-input input,cf-input textarea{resize:none;overflow:hidden;padding:calc((60px - 4px - 18px)/ 2) 60px calc((60px - 4px - 18px)/ 2) calc((60px - 2px - 18px)/ 2)}cf-input input,cf-input textarea{outline:0;-webkit-appearance:none;-webkit-touch-callout:auto!important;-webkit-user-select:auto!important;-moz-user-select:auto!important;-ms-user-select:auto!important;user-select:auto!important;border-radius:0;border:none;-webkit-appearance:none;position:relative;z-index:2;display:block;font-family:"Helvetica Neue","Neue Helvetica W01",Helvetica,Arial,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol",sans-serif;font-size:18px;width:100%;height:60px;min-height:60px;color:#4b4f56;will-change:box-shadow,background,color,transform,opacity;background:#fff;box-shadow:0 0 1px rgba(0,0,0,.35);opacity:0;transform:translateY(40px) rotateX(-40deg);transition:all .3125s!important}cf-input input:-webkit-autofill,cf-input textarea:-webkit-autofill{background-color:#fff}cf-input input:active,cf-input input:focus,cf-input textarea:active,cf-input textarea:focus{box-shadow:0 0 6px rgba(0,0,0,.3)}.conversational-form--enable-animation cf-input input,.conversational-form--enable-animation cf-input textarea{transition:box-shadow .75s cubic-bezier(.215,.61,.355,1),background .75s cubic-bezier(.215,.61,.355,1),color .75s cubic-bezier(.215,.61,.355,1),transform 375ms cubic-bezier(.175,.885,.32,1.275) 0s,opacity 375ms cubic-bezier(.215,.61,.355,1) 0s}cf-input input:hover::-webkit-input-placeholder,cf-input textarea:hover::-webkit-input-placeholder{color:#040404}cf-input input:hover::-moz-input-placeholder,cf-input textarea:hover::-moz-input-placeholder{color:#040404}cf-input input:hover:-moz-input-placeholder,cf-input textarea:hover:-moz-input-placeholder{color:#040404}cf-input input:hover:-ms-input-placeholder,cf-input textarea:hover:-ms-input-placeholder{color:#040404}cf-input input::-webkit-input-placeholder,cf-input textarea::-webkit-input-placeholder{color:currentColor}cf-input input::-moz-input-placeholder,cf-input textarea::-moz-input-placeholder{color:currentColor}cf-input input:-moz-input-placeholder,cf-input textarea:-moz-input-placeholder{color:currentColor}cf-input input:-ms-input-placeholder,cf-input textarea:-ms-input-placeholder{color:currentColor}cf-input input[no-animations],cf-input textarea[no-animations]{transition:none!important}cf-input input[rows='1'],cf-input textarea[rows='1']{min-height:60px!important}cf-input input:not([rows="1"]),cf-input textarea:not([rows="1"]){transition-delay:.9s!important}cf-input input[rows="2"],cf-input textarea[rows="2"]{min-height:80px!important}cf-input input[rows="3"],cf-input textarea[rows="3"]{min-height:100px!important}cf-input input[rows="4"],cf-input textarea[rows="4"]{min-height:120px!important}cf-input input[rows="5"],cf-input textarea[rows="5"]{min-height:140px!important}cf-input input[rows="6"],cf-input textarea[rows="6"]{min-height:160px!important}cf-input.hide-input input,cf-input.hide-input textarea{display:none}cf-input.hide-input cf-input-button{display:none}cf-input[disabled=disabled]{pointer-events:none}cf-input[disabled=disabled] input,cf-input[disabled=disabled] textarea{background:rgba(232,233,235,.5)}cf-input[disabled=disabled] .cf-input-button{background:rgba(232,233,235,.75)}cf-input cf-icon-audio-eq{display:block;border:0 solid grey;border-color:#00c2df;width:100%;height:100%;border-radius:50%;z-index:0;position:absolute;top:0;left:0}cf-input[error]{pointer-events:none}cf-input[error] input,cf-input[error] textarea{background:#ffebe9;color:#fe8d84}cf-input[error] .cf-input-button{background:#ffebe9}cf-input[error] .cf-input-button svg polygon{fill:#fe8d84}cf-input[message] input,cf-input[message] textarea{background:#00c2df;color:#13e0ff}cf-input[message] .cf-input-button{background:#00c2df}cf-input[message] .cf-input-button svg polygon{fill:#13e0ff}cf-input[tag-type=file] cf-input-button.cf-input-button.loading:after{content:"";display:block;position:relative;left:calc(50% - (60px / 4));top:calc(50% - (60px / 4));width:30px;height:30px;border:1px solid #b9bcbe;border-radius:50%;border-left:0;border-top:0;animation:cf-spin 1s linear infinite;will-change:opacity}.conversational-form--enable-animation cf-input[tag-type=file] cf-input-button.cf-input-button.loading:after{transition:opacity 375ms cubic-bezier(.215,.61,.355,1)}cf-input[tag-type=file] cf-input-button.cf-input-button div.cf-icon-attachment{transform:rotateX(0);opacity:1}cf-input[tag-type=file] cf-input-button.cf-input-button div.cf-icon-progress{transform:rotateX(-90deg);rotateZ(90deg);opacity:0}cf-input-button.cf-input-button{width:60px;height:100%;background:#00c2df;position:absolute;overflow:hidden;right:0;bottom:0;z-index:3;cursor:pointer;border-radius:0;will-change:background,border;transform-origin:50% 50%;transform:scale(0,0);-webkit-backface-visibility:hidden;backface-visibility:hidden;border:none}.conversational-form--enable-animation cf-input-button.cf-input-button{transition:background 375ms cubic-bezier(.215,.61,.355,1),border 375ms cubic-bezier(.215,.61,.355,1),transform 375ms cubic-bezier(.175,.885,.32,1.275) 0s}cf-input-button.cf-input-button .cf-input-icons.cf-microphone{transform:scale(0,0);pointer-events:none}cf-input-button.cf-input-button.microphone-interface .cf-input-icons{transform-origin:50% 50%;transform:scale(1,1) rotateX(0) translateZ(0);transition:transform 375ms cubic-bezier(.215,.61,.355,1)}cf-input-button.cf-input-button.microphone-interface .cf-input-icons:not(.cf-microphone){pointer-events:none;transform:scale(.25,.25) rotateX(90deg) translateZ(0)}cf-input-button.cf-input-button.microphone-interface .cf-input-icons.cf-microphone{pointer-events:auto;transform:scale(1,1) rotateX(0) translateZ(0)}cf-input-button.cf-input-button.microphone-interface.loading:not(.typing){pointer-events:none}cf-input-button.cf-input-button.microphone-interface.loading:not(.typing) .cf-microphone div.cf-icon-audio{opacity:1}cf-input-button.cf-input-button.microphone-interface.typing .cf-input-icons:not(.cf-microphone){pointer-events:auto;transform:scale(1,1) rotateX(0) translateZ(0)}cf-input-button.cf-input-button.microphone-interface.typing .cf-input-icons.cf-microphone{transform:scale(.25,.25) rotateX(90deg) translateZ(0);pointer-events:none}cf-input-button.cf-input-button .cf-input-icons{position:absolute;z-index:1;pointer-events:none;width:100%;height:100%}cf-input-button.cf-input-button .cf-input-icons>div{width:100%;height:100%;position:absolute;z-index:1;background-repeat:no-repeat;background-position:50% 50%;transform-origin:50% 50%;will-change:transform,opacity}.conversational-form--enable-animation cf-input-button.cf-input-button .cf-input-icons>div{transition:transform 375ms cubic-bezier(.215,.61,.355,1),opacity 375ms cubic-bezier(.215,.61,.355,1)}cf-input-button.cf-input-button div.cf-icon-attachment{transform:rotateX(90deg);opacity:0;background-image:url("data:image/svg+xml;charset=UTF-8,%3Csvg width='12px' height='16px' viewBox='0 0 12 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg transform='translate%28-573.000000, -605.000000%29' stroke='%23E8E9EB'%3E%3Cg transform='translate%2884.000000, 136.000000%29'%3E%3Cg transform='translate%281.000000, 456.000000%29'%3E%3Cpath d='M499,23.1092437 L499,18.907563 C499,16.2016807 496.756849,14 494,14 C491.243151,14 489,16.2016807 489,18.907563 L489,24.5042017 C489,26.4369748 490.592466,28 492.561644,28 C494.530822,28 496.123288,26.4369748 496.123288,24.5042017 L496.123288,18.907563 C496.140411,17.7478992 495.181507,16.8067227 494,16.8067227 C492.818493,16.8067227 491.859589,17.7478992 491.859589,18.907563 L491.859589,23.1092437'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");background-size:18px 24px}cf-input-button.cf-input-button div.cf-icon-progress{transform:rotateX(0);rotateZ(90deg);opacity:1;background-image:url("data:image/svg+xml;charset=UTF-8,%3Csvg width='30px' height='30px' viewBox='0 0 30 30' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg fill='%23E8E9EB'%3E%3Cpolygon transform='translate%2815.500000, 15.500000%29 rotate%2890.000000%29 translate%28-15.500000, -15.500000%29 ' points='22 14.6875 12.111875 14.6875 16.6496875 10.1496875 15.5 9 9 15.5 15.5 22 16.6496875 20.8503125 12.111875 16.3125 22 16.3125'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/svg%3E");background-size:45px 45px}cf-input-button.cf-input-button div.cf-icon-audio{transform:rotateX(0);opacity:1;background-image:url("data:image/svg+xml;charset=UTF-8,%3C?xml version='1.0' encoding='utf-8'?%3E%3C!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0%29 --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='512px' height='512px' fill='%23E8E9EB' viewBox='0 0 512 512' enable-background='new 0 0 512 512' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M256,320c37.712,0,68.571-30.924,68.571-68.714V100.714C324.571,62.924,293.712,32,256,32s-68.571,30.924-68.571,68.714 v150.572C187.429,289.076,218.288,320,256,320z M377.139,244.548c0,68.714-58.282,116.815-121.139,116.815 s-121.139-48.102-121.139-116.815H96c0,77.873,61.719,143.153,137.144,153.465V480h45.713v-81.987 C354.281,386.561,416,322.421,416,244.548H377.139z'/%3E%3C/g%3E%3C/svg%3E");background-size:39px 39px}cf-input-button.cf-input-button:active{opacity:.2}cf-input-button.cf-input-button:focus,cf-input-button.cf-input-button:hover{background:#00c2df;border:0}cf-input-button.cf-input-button:focus:after,cf-input-button.cf-input-button:hover:after{opacity:0}@media (min-width:1152px){cf-input-button.cf-input-button:focus .cf-icon-progress,cf-input-button.cf-input-button:hover .cf-icon-progress{animation:cf-arrow-up .75s cubic-bezier(.645,.045,.355,1)}}cf-input[tag-type=file] cf-input-button.cf-input-button,cf-input[tag-type=group] cf-input-button.cf-input-button,cf-input[tag-type=select] cf-input-button.cf-input-button{height:60px}cf-input[tag-type=file].hide-input cf-input-button,cf-input[tag-type=group].hide-input cf-input-button,cf-input[tag-type=select].hide-input cf-input-button{display:block;left:0;right:0;margin-left:auto;margin-right:auto}cf-input[tag-type=file].hide-input cf-input-control-elements,cf-input[tag-type=group].hide-input cf-input-control-elements,cf-input[tag-type=select].hide-input cf-input-control-elements{margin-bottom:60px}cf-input[error=""].hide-input cf-input-button .cf-icon-progress{filter:saturate(0);animation:shake .6s cubic-bezier(.36,.07,.19,.97) both}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(1px,0,0)}30%,50%,70%{transform:translate3d(-2px,0,0)}40%,60%{transform:translate3d(2px,0,0)}}@keyframes cf-spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes cf-arrow-up{0%{transform:translateY(0)}40%{transform:translateY(-40px)}40.001%{transform:translateY(40px)}80%{transform:translateY(-5px)}90%{transform:translateY(2px)}100%{transform:translateY(0)}}cf-input-control-elements.animate-in cf-list-button{opacity:1}cf-input-control-elements.hide-nav-buttons cf-list-button{pointer-events:none}cf-input-control-elements.hide-nav-buttons cf-list-button:after{opacity:0}cf-list-button{display:block;position:absolute;z-index:2;height:calc(100% - 16px);width:38px;cursor:pointer;opacity:0;pointer-events:none;will-change:opacity}.conversational-form--enable-animation cf-list-button{transition:opacity .75s cubic-bezier(.215,.61,.355,1) .5s}@media (min-width:1152px){cf-list-button:hover:nth-child(1){background:linear-gradient(to left,rgba(255,255,255,0) 0,#fff 75%)}cf-list-button:hover:nth-child(1):after{animation:cf-arrow-left .75s cubic-bezier(.645,.045,.355,1)}cf-list-button:hover:nth-child(2){background:linear-gradient(to right,rgba(255,255,255,0) 0,#fff 75%)}cf-list-button:hover:nth-child(2):after{animation:cf-arrow-right .75s cubic-bezier(.645,.045,.355,1)}}cf-list-button.cf-gradient:before{opacity:1}cf-list-button.active{pointer-events:auto}cf-list-button.active:after{opacity:1}cf-list-button:active:after{visibility:hidden}cf-list-button:nth-child(1){left:0}cf-list-button:nth-child(1):before{background:linear-gradient(to left,rgba(255,255,255,0) 0,#fff 100%)}cf-list-button:nth-child(1):after{background-image:url("data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='UTF-8' standalone='no'?%3e%3csvg viewBox='0 0 6 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg stroke='none' stroke-width='1' fill='%23000000' fill-rule='evenodd'%3e%3cg transform='translate%28-1230.000000, -567.000000%29' %3e%3cg transform='translate%28738.000000, 178.000000%29'%3e%3cg transform='translate%280.000000, 340.000000%29'%3e%3cg transform='translate%28466.000000, 0.000000%29'%3e%3cpolygon transform='translate%2829.000000, 54.000000%29 rotate%28-180.000000%29 translate%28-29.000000, -54.000000%29 ' points='26 50.1538462 27.125 49 32 54 27.125 59 26 57.8461538 29.75 54'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e")}cf-list-button:nth-child(2){right:0}cf-list-button:nth-child(2):before{background:linear-gradient(to right,rgba(255,255,255,0) 0,#fff 100%)}cf-list-button:nth-child(2):after{background-image:url("data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='UTF-8' standalone='no'?%3e%3csvg viewBox='0 0 6 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg stroke='none' stroke-width='1' fill='%23000000' fill-rule='evenodd'%3e%3cg transform='translate%28-1230.000000, -567.000000%29'%3e%3cg transform='translate%28738.000000, 178.000000%29'%3e%3cg transform='translate%280.000000, 340.000000%29'%3e%3cg transform='translate%28466.000000, 0.000000%29'%3e%3cpolygon points='26 50.1538462 27.125 49 32 54 27.125 59 26 57.8461538 29.75 54'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e")}cf-list-button:before{content:"";display:block;width:100%;height:100%;opacity:0;will-change:opacity}.conversational-form--enable-animation cf-list-button:before{transition:opacity .75s cubic-bezier(.215,.61,.355,1)}cf-list-button:after{content:"";display:block;width:6px;height:10px;position:absolute;background-size:6px 10px;background-repeat:no-repeat;top:calc(50% - 5px);left:calc(50% - 3px);opacity:0;will-change:opacity}.conversational-form--enable-animation cf-list-button:after{transition:opacity 375ms cubic-bezier(.215,.61,.355,1)}@keyframes cf-arrow-right{0%{transform:translateX(0);opacity:1}40%{transform:translateX(20px);opacity:0}40.001%{transform:translateX(-20px);opacity:0}80%{transform:translateX(4px);opacity:1}90%{transform:translateX(-2px);opacity:1}100%{transform:translateX(0);opacity:1}}@keyframes cf-arrow-left{0%{transform:translateX(0);opacity:1}40%{transform:translateX(-20px);opacity:0}40.001%{transform:translateX(20px);opacity:0}80%{transform:translateX(-4px);opacity:1}90%{transform:translateX(2px);opacity:1}100%{transform:translateX(0);opacity:1}}.cf-progressBar{background-color:#fff;width:100%;height:3px;z-index:999;position:absolute;top:0;left:0;opacity:0;transition:opacity .5s ease-in-out;will-change:opacity}.cf-progressBar.show{opacity:1}.cf-progressBar .bar{width:0;height:100%;background-color:#00c2df;transition:width .3s ease-in-out;will-change:width}cf-chat{display:block;width:100%;height:auto;min-height:100%;overflow:hidden;display:flex;flex-flow:column nowrap;justify-content:flex-end;align-items:baseline;margin-bottom:-10px}cf-chat scrollable{width:calc(100% + 40px);padding-right:40px;max-height:100%;min-height:40px;flex-grow:1;display:flex;flex-direction:column-reverse;overflow-y:scroll}@supports (-ms-ime-align:auto){cf-chat scrollable{overflow:hidden}}cf-chat .scrollableInner{position:relative;display:flex;flex:0 0 auto;flex-direction:column;padding-bottom:10px;padding-top:40px;overflow:hidden}cf-chat .scrollableInner.scroll{flex:1 1 auto;height:100%;overflow-y:scroll;margin-bottom:20px}@supports (-ms-ime-align:auto){cf-chat .scrollableInner.scroll{margin-right:-16px}}.conversational-form.done cf-chat-response{pointer-events:none}cf-chat-response{max-width:90%;min-width:120px;position:relative;-webkit-backface-visibility:hidden;backface-visibility:hidden;padding-left:62px;margin-top:8px;color:#33363b;margin-left:0;margin-right:auto;word-break:break-all;display:flex;flex-shrink:0;flex-grow:1;position:absolute;visibility:hidden;will-change:height;transition:height .3375s cubic-bezier(.215,.61,.355,1);padding-bottom:12px}@media (min-width:1152px){cf-chat-response{max-width:70%}}@media (max-width:1152px){cf-chat-response{padding-left:47.71429px}}cf-chat-response.show{position:relative;visibility:visible}cf-chat-response.can-edit{cursor:pointer}cf-chat-response.can-edit:hover text>p{background:#009fb6}cf-chat-response.user{justify-content:flex-end;margin-right:0;margin-left:auto;padding-left:0;padding-right:calc(50px + 14px);color:#fff}@media (max-width:1152px){cf-chat-response.user{padding-right:47.71429px}}cf-chat-response.user thumb{left:auto;right:0}cf-chat-response.user text>p{background:#00c2df;border-radius:24px 0 24px 24px;margin-right:0;margin-left:auto}cf-chat-response.user.peak-thumb thumb{transform:scale(1,1) translateY(0);opacity:1}.conversational-form--enable-animation cf-chat-response.user.peak-thumb thumb{transition-delay:.2s,.2s,.2s}cf-chat-response.robot.peak-thumb thumb{transform:scale(1,1) translateY(0);opacity:1}.conversational-form--enable-animation cf-chat-response.robot.peak-thumb thumb{transition-delay:.2s,.2s,.2s}cf-chat-response.disabled{pointer-events:none;color:#6e747f}cf-chat-response.disabled text{background:#dffbff}cf-chat-response[thinking] text thinking{display:block}cf-chat-response text{display:flex;flex-flow:column;align-items:start;position:relative;min-height:40px;height:auto;white-space:pre-wrap;word-break:normal;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}cf-chat-response text>div{display:inline-block}cf-chat-response text thinking span:nth-child(1){animation-delay:.66667 s}cf-chat-response text thinking span:nth-child(2){animation-delay:1.33333 s}cf-chat-response text thinking span:nth-child(3){animation-delay:2 s}cf-chat-response text strong{font-weight:900}cf-chat-response text>p{display:inline-block;margin:0;padding:0;background:#e8e9eb;padding:14px 21px 14px 21px;border-radius:0 24px 24px 24px;transition:background 375ms cubic-bezier(.215,.61,.355,1)}@media (max-width:1152px){cf-chat-response text>p{padding:9px 17px 11px 17px}}.conversational-form--enable-animation cf-chat-response text>p{will-change:transform,opacity;transform:scale(0,0) translateY(30px);opacity:0}.conversational-form--enable-animation cf-chat-response text>p.show{animation:moveIn .2625s forwards 375ms cubic-bezier(.215,.61,.355,1)}cf-chat-response text>p.hasImage{padding:0;overflow:hidden;background:0 0}cf-chat-response text>p.hasImage img{margin:0;padding:0}cf-chat-response text>p.hasImage>span{display:block;padding:5px 6px 6px 18px;background:#00c2df}cf-chat-response text>p:not(:only-child){border-radius:0 24px 24px 0}cf-chat-response text>p:not(:only-child):first-child{border-radius:24px 24px 24px 0}cf-chat-response text>p:not(:only-child):last-child{border-radius:0 24px 24px 24px}cf-chat-response text>p:not(:only-child):not(:first-child){margin-top:6px}cf-chat-response text>p>img{max-width:140px;padding-bottom:8px;width:100%;height:auto;display:block;margin-bottom:6px}cf-chat-response text:after{content:"";display:block;position:absolute;top:50%;left:30px;transform:translateY(-50%);padding-right:30px}cf-chat-response text thinking{position:relative;display:table;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:none;transform-origin:0 50%;transform:scale(1.5)}cf-chat-response text thinking span:nth-child(1){animation:dot-fade 1s linear .33333 s infinite}cf-chat-response text thinking span:nth-child(2){animation:dot-fade 1s linear .66667 s infinite}cf-chat-response text thinking span:nth-child(3){animation:dot-fade 1s linear 1 s infinite}cf-chat-response text svg.cf-icon-file{width:15px;height:auto;display:inline-block;margin-right:11px}cf-chat-response text svg.cf-icon-file g{fill:#e8e9eb}cf-chat-response thumb{position:absolute;top:0;left:0;display:block;width:50px;height:50px;border-radius:50%;background:#e8e9eb;background-size:cover;background-repeat:no-repeat;background-position:50% 50%;opacity:0;overflow:hidden;transform-origin:50% 50%;transform:scale(.001,.001) translateY(50px);will-change:transform,opacity}@media (max-width:1152px){cf-chat-response thumb{width:39.68254px;height:39.68254px}}.conversational-form--enable-animation cf-chat-response thumb{transition:transform .2625s cubic-bezier(.215,.61,.355,1),opacity 375ms cubic-bezier(.215,.61,.355,1)}cf-chat-response thumb>span{display:block;line-height:36px;text-align:center;font-weight:700;font-size:14.4px}cf-chat-response thumb>span[length="1"]{font-size:28.8px}cf-chat-response thumb>span[length="3"]{font-size:11.88px}@keyframes dot-fade{0%{opacity:1}15.1111%{opacity:0}33.333%{opacity:1}100%{opacity:1}}@keyframes bounce{0%{transform:scale(1,1);opacity:1}50%{transform:scale(1.05,1.05);opacity:.85}100%{transform:scale(1,1);opacity:1}}@keyframes moveIn{0%{transform:scale(1,1) translateY(60px);opacity:0}100%{transform:scale(1,1) translateY(0);opacity:1}}cf-input-control-elements{width:auto;height:auto;overflow:hidden;display:block;position:relative;z-index:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;visibility:hidden;height:auto;padding-top:10px;padding-bottom:10px}cf-input-control-elements .cf-button{margin-bottom:10px;display:inline-block}cf-input-control-elements .cf-button.hide{display:none}cf-input-control-elements.resized{visibility:visible;height:auto}cf-input-control-elements.one-row cf-list{height:auto}cf-input-control-elements.one-row cf-list-button{opacity:0}cf-input-control-elements.two-row cf-list{white-space:normal;height:auto}cf-input-control-elements.animate-in cf-list:last-of-type{min-height:56px}cf-input-control-elements.two-row.animate-in cf-list:last-of-type{min-height:112px}cf-list,cf-list-button{will-change:height}.conversational-form--enable-animation cf-list,.conversational-form--enable-animation cf-list-button{transition:height 375ms cubic-bezier(.215,.61,.355,1)}cf-input[tag-type=file] cf-list{cursor:default}cf-input[tag-type=file] cf-input-control-elements{margin-bottom:0}cf-list{display:block;height:auto;cursor:move;white-space:nowrap}cf-list.disabled{pointer-events:none}.cf-button{background:#fff;cursor:pointer;border:1px solid #00c2df;border-radius:calc(24px * .88);color:#00c2df;line-height:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;transform:translateZ(0);font-size:16px;transform-origin:0 100%;will-change:opacity,background;opacity:0}@media (max-width:1152px){.cf-button{font-size:14px}}.cf-button>div{position:relative;margin:12px 22px}@media (max-width:1152px){.cf-button>div{margin:10px 22px}}.cf-button.has-image{max-width:160px}@media (max-width:1152px){.cf-button.has-image{max-width:132px}}.cf-button.has-image>div{margin:8px 22px 10px 22px}.conversational-form--enable-animation .cf-button{transition:opacity 0s cubic-bezier(.215,.61,.355,1),background .75s cubic-bezier(.215,.61,.355,1)}.cf-button.animate-in{opacity:1}.conversational-form--enable-animation .cf-button.animate-in{transition-duration:375ms,.75s;transition-timing-function:cubic-bezier(.215,.61,.355,1),cubic-bezier(.215,.61,.355,1)}.conversational-form--enable-animation .cf-button.animate-in:nth-child(even){transition-delay:50ms,0s}.conversational-form--enable-animation .cf-button.animate-in:nth-child(odd){transition-delay:.15s,0s}.cf-button.animate-in.animate-out{transform-origin:75% 100%;opacity:0}.cf-button:not(:last-child){margin-right:10px}.cf-button:focus,.cf-button:focus:not([checked=checked]),.cf-button:hover,.cf-button:hover:not([checked=checked]){background:#00a8c2;color:#e8e9eb}.cf-button[checked=checked]:not(:focus):not(:hover):not(.highlight),.cf-button[selected=selected]:not(:focus):not(:hover):not(.highlight){color:#e8e9eb;background:#00a8c2}.cf-button[disabled=disabled]{pointer-events:none}.cf-button[disabled=disabled].animate-in{opacity:.5}.cf-button:active>div{opacity:.2}.cf-button .cf-image{width:100%;height:auto;will-change:opacity;transition:opacity .75s cubic-bezier(.215,.61,.355,1);opacity:0}.cf-button .cf-image.loaded{opacity:1}.cf-button.cf-checkbox-button:focus cf-checkbox,.cf-button.cf-checkbox-button:hover cf-checkbox{background:#00a8c2}.cf-button.cf-checkbox-button:focus cf-checkbox:after,.cf-button.cf-checkbox-button:hover cf-checkbox:after{transform:scale(1,1);top:1px;left:0;width:15px;height:12px;background-image:url("data:image/svg+xml;charset=UTF-8,%3csvg width='13px' height='10px' viewBox='0 0 13 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e%3cg transform='translate%28-290.000000, -505.000000%29' fill='%23E8E9EB'%3e%3cg transform='translate%2884.000000, 136.000000%29'%3e%3cg transform='translate%281.000000, 216.000000%29'%3e%3cg transform='translate%28189.000000, 139.000000%29'%3e%3cpolygon points='17.5 18.5 16 20 20 24 29 15.5 27.5 14 20 21'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e");background-size:15px 12px;transform-origin:50% 50%}.cf-button.cf-checkbox-button.no-text{padding:18px 24px}.cf-button.cf-checkbox-button.no-text cf-checkbox{margin-right:0;margin-left:0}.cf-button.cf-checkbox-button.has-image cf-checkbox{margin-left:0}.cf-button.cf-checkbox-button cf-checkbox{display:block;float:left;width:14px;height:14px;border-radius:3px;border:1px solid #00c2df;will-change:background;margin-right:8px;margin-left:-10px;margin-top:1px;position:relative}.conversational-form--enable-animation .cf-button.cf-checkbox-button cf-checkbox{transition:background 375ms cubic-bezier(.215,.61,.355,1)}.cf-button.cf-checkbox-button cf-checkbox:after{content:"";position:absolute;top:1px;left:0;display:block;width:15px;height:12px;background-image:url("data:image/svg+xml;charset=UTF-8,%3csvg width='13px' height='10px' viewBox='0 0 13 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e%3cg transform='translate%28-290.000000, -505.000000%29' fill='%23E8E9EB'%3e%3cg transform='translate%2884.000000, 136.000000%29'%3e%3cg transform='translate%281.000000, 216.000000%29'%3e%3cg transform='translate%28189.000000, 139.000000%29'%3e%3cpolygon points='17.5 18.5 16 20 20 24 29 15.5 27.5 14 20 21'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e");background-size:15px 12px;background-repeat:no-repeat;transform-origin:50% 50%;will-change:transform;transform:scale(0,0)}.conversational-form--enable-animation .cf-button.cf-checkbox-button cf-checkbox:after{transition:transform .1875s cubic-bezier(.215,.61,.355,1)}.cf-button.cf-checkbox-button[checked=checked],.cf-button.cf-checkbox-button[selected=selected]{background:#00c2df!important;color:#e8e9eb!important}.cf-button.cf-checkbox-button[checked=checked] cf-checkbox,.cf-button.cf-checkbox-button[selected=selected] cf-checkbox{background:rgba(0,194,223,0);border:none}.cf-button.cf-checkbox-button[checked=checked] cf-checkbox:after,.cf-button.cf-checkbox-button[selected=selected] cf-checkbox:after{transform:scale(1,1)}.conversational-form--enable-animation .cf-button.cf-checkbox-button[checked=checked] cf-checkbox:after,.conversational-form--enable-animation .cf-button.cf-checkbox-button[selected=selected] cf-checkbox:after{transition-timing-function:cubic-bezier(.215,.61,.355,1)}cf-options-list{display:block;width:auto}cf-radio-button.cf-button.highlight cf-radio,cf-radio-button.cf-button:focus cf-radio,cf-radio-button.cf-button:hover cf-radio{background:#e8e9eb}cf-radio-button.cf-button.has-image cf-checkbox{margin-left:0}cf-radio-button.cf-button cf-radio{display:block;float:left;width:12px;height:12px;border-radius:50%;background:0 0;border:1px solid #00c2df;will-change:background;margin-right:8px;margin-left:-10px;margin-top:2px;position:relative}.conversational-form--enable-animation cf-radio-button.cf-button cf-radio{transition:background 375ms cubic-bezier(.215,.61,.355,1)}cf-radio-button.cf-button[checked=checked]{background:#00c2df!important;color:#e8e9eb!important}cf-radio-button.cf-button[checked=checked] cf-radio{background:#fff;border:1px solid #fff;pointer-events:none}cf-upload-file-ui{display:block;width:100%;height:60px;position:relative;top:0;color:#13e0ff;opacity:0;transform:translateY(20px) rotateX(30deg);will-change:opacity,transform}.conversational-form--enable-animation cf-upload-file-ui{transition:opacity 375ms cubic-bezier(.215,.61,.355,1),transform 375ms cubic-bezier(.215,.61,.355,1)}cf-upload-file-ui.animate-in{opacity:1;transform:translateY(0) rotateX(0)}.conversational-form--enable-animation cf-upload-file-ui.animate-in{transition-timing-function:cubic-bezier(.215,.61,.355,1),cubic-bezier(.215,.61,.355,1)}cf-upload-file-text{display:block;float:left;width:auto;height:100%;padding-right:20px;padding-top:17px;position:relative;color:currentColor;width:50%;text-overflow:ellipsis;overflow:hidden}cf-upload-file-text:before{content:"";display:inline-block;position:absolute;top:17px;left:23px;width:10px;height:14px;background-image:url("data:image/svg+xml;charset=UTF-8,%3csvg viewBox='0 0 10 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e%3cg transform='translate(-756.000000, -549.000000)' fill='#e8e9eb'%3e%3cg transform='translate(736.000000, 127.000000)'%3e%3cg transform='translate(0.000000, 406.000000)'%3e%3cpolygon points='20 16 26.0030799 16 30 19.99994 30 30 20 30'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e");background-repeat:no-repeat;background-size:10px 14px}cf-upload-file-progress{display:block;height:100%;overflow:hidden;position:relative;float:right;width:50%}cf-upload-file-progress:after{content:"";width:100%;background:#f7f7f7;border-radius:7px}cf-upload-file-progress cf-upload-file-progress-bar,cf-upload-file-progress:after{display:block;height:10px;position:absolute;top:19px;z-index:1}cf-upload-file-progress cf-upload-file-progress-bar{width:0%;will-change:width,border-radius;background:currentColor;z-index:2;border-radius:7px}.conversational-form--enable-animation cf-upload-file-progress cf-upload-file-progress-bar{transition:width .15s linear,border-radius 375ms cubic-bezier(.215,.61,.355,1)}cf-upload-file-progress cf-upload-file-progress-bar.loaded{border-radius:7px 7px 7px 7px}

`;
